/** 鉴权失效错误标记：拦截器已用后端 message 提示，业务 catch 勿再覆盖 */
export const UNAUTHORIZED_ERROR_CODE = "UNAUTHORIZED";

type ApiErrorLike = {
  code?: string;
  message?: unknown;
  status?: number;
  statusCode?: number;
};

function asApiErrorLike(err: unknown): ApiErrorLike | undefined {
  if (err && typeof err === "object") return err as ApiErrorLike;
  return undefined;
}

/** 从后端/axios 错误中解析可读 message */
export function getApiErrorMessage(err: unknown, fallback: string): string {
  if (err instanceof Error && err.message.trim()) return err.message;
  if (typeof err === "string" && err.trim()) return err;

  const body = asApiErrorLike(err);
  const message = body?.message;
  if (typeof message === "string" && message.trim()) return message;
  if (Array.isArray(message) && message.length > 0) {
    const joined = message
      .filter((item) => typeof item === "string")
      .join("; ");
    if (joined) return joined;
  }
  return fallback;
}

export function isUnauthorizedError(err: unknown): boolean {
  const body = asApiErrorLike(err);
  if (body?.code === UNAUTHORIZED_ERROR_CODE) return true;
  if (
    err instanceof Error &&
    (err as Error & { code?: string }).code === UNAUTHORIZED_ERROR_CODE
  ) {
    return true;
  }
  return (
    body?.statusCode === 401 || body?.status === 401 || body?.status === 40101
  );
}

/**
 * 解析应展示的 API 错误文案。
 * 返回 null：401 已由 request 拦截器用后端 message 提示，调用方勿再 toast。
 */
export function resolveApiErrorToastMessage(
  err: unknown,
  fallback: string
): string | null {
  if (
    err instanceof Error &&
    (err as Error & { code?: string }).code === UNAUTHORIZED_ERROR_CODE
  ) {
    return null;
  }
  return getApiErrorMessage(err, fallback);
}

/** 构造带 UNAUTHORIZED 标记的 Error，供拦截器 reject */
export function createUnauthorizedError(
  message: string
): Error & { code: string } {
  const err = new Error(message) as Error & { code: string };
  err.code = UNAUTHORIZED_ERROR_CODE;
  return err;
}
